import { Module } from 'vuex-smart-module';
import ModelAccreditationActions from './actions';
import ModelAccreditationGetters from './getters';
import ModelAccreditationMutations from './mutations';
import ModelAccreditationState from './state';

export default new Module({
  state: ModelAccreditationState,
  mutations: ModelAccreditationMutations,
  actions: ModelAccreditationActions,
  getters: ModelAccreditationGetters,
});
